<template>
    <div class="front-form">
      <div class="d-flex justify-center mb-8">
        <logo></logo>
      </div>
        <div class="front-form__wrap">
            <v-card class="elevation-12 front-form__block">
                <v-toolbar dark color="primary login__logotype">
                    <v-toolbar-title>{{ $t('msg.recoveryPassword') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form @submit.prevent="">
                        <v-text-field
                                prepend-icon="mdi-email"
                                name="email"
                                label="Email"
                                type="email"
                                v-model="model.email"
                                v-validate="'required|email'"
                                :error-messages="errors.collect('email')"
                                @keyup.enter="onSubmit()"
                                outlined
                                dense
                                hide-details="auto"
                                class="mt-4"
                                ref="email"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-3 pl-4 pr-4">
                    <c-btn
                            color="primary"
                            @click="onSubmit"
                            :disabled="loading"
                            :loading="loading"
                            class="mr-2 mb-2"
                            width="100%"
                            mobile
                    >{{ $t('msg.recovery') }}</c-btn>
                </v-card-actions>
            </v-card>
        </div>
        <div class="front-form__links">
          <c-btn
            :to="{name: 'login', query: {email: model.email}}"
            color="secondary"
          >{{ $t('msg.loginAuth') }}</c-btn>
        </div>
      <div class="d-flex justify-center mt-12">
        <support
          style="width: 400px;"
          :msg="$t('msg.errorLoginToSupport')"
        ></support>
      </div>
    </div>
</template>

<script>
    import CBtn from "@/components/ui/CBtn";
    import Support from "@/components/block/Support";
    import Logo from "@/components/block/Logo";

    export default {
      components: {CBtn, Support, Logo},
        data () {
            return {
                model: {
                    email: null
                },
                loading: false
            }
        },
        methods: {
            onSubmit () {
                this.$validator.validateAll()
                    .then(res => {
                        if (res) {
                            this.loading = true;
                            this.$store.dispatch('recoveryPassword', {
                                data: this.model,
                                formErrors: this.$validator.errors
                            })
                                .then(() => {
                                    this.$store.commit('setSnackBarInfo', this.$t('msg.furtherInstructionsSentEmail'));
                                    this.$router.push({name: 'login'});
                                })
                                .finally(() => this.loading = false);
                        }
                    });
            },
        },
      mounted() {
        this.$nextTick(() => {
          this.$refs.email.focus();
        });
      },
        created() {
          if (this.$route.query.email !== undefined) {
            this.model.email = this.$route.query.email;
          }
        }
    }
</script>

<style lang="scss">
    .login__logotype {
        .v-toolbar__content {
            display: flex;
            justify-content: center;
        }
    }
</style>